module.exports = __webpack_public_path__ + "media/images/select2x2-8b3bc7f1b52499a14f031f75f680f2a4.png";